import axios from "../axiosInstance";
import { UpdateTradeRevenueRequest, UpdateTradeRevenueResponse } from "./types";

export const updateTradeRevenue = async (
  data: UpdateTradeRevenueRequest,
): Promise<UpdateTradeRevenueResponse> => {
  const response = await axios.put<UpdateTradeRevenueResponse>(
    "/api/private/my-company-profile/trade-revenue",
    data,
  );
  return response.data;
};
